import React from 'react';
import ReactDOM from 'react-dom';

import OrderList from 'components/OrderList';


function initOrderList(
    initial, nextQParam, ordNumber, ordClientName, ordCustomerNumber, ordArticleCode, ordDeliveryDate, ordQCRequired,
) {
    const elem = document.getElementById('order-list-container');
    if (!elem) {
        return;
    }

    ReactDOM.render(
        <OrderList
            {...initial}
            nextQueryParam={nextQParam}
            ordering={{
                number: ordNumber,
                clientName: ordClientName,
                customerNumber: ordCustomerNumber,
                articleCode: ordArticleCode,
                deliveryDate: ordDeliveryDate,
                QCRequired: ordQCRequired,
            }}
        />,
        elem,
    );
}


export default initOrderList;



// WEBPACK FOOTER //
// ./src/views/OrderList.js